import { useState } from "react";
import { Download, ExternalLink, Megaphone } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/States";
import ShareBar from "@/components/ShareBar";

export default function ShareKit({ project }) {
  const { workspace } = useAuth();
  const [busy, setBusy] = useState(false);
  const api_base = process.env.REACT_APP_BACKEND_URL;
  const complete = project.status === "complete" && project.in_lookbook !== false;
  const shareUrl = `${api_base}/api/share/lookbook/${workspace.slug}?project=${project.id}`;
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/projects/${project.id}/share-kit.zip`, { responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `${project.name}-share-kit.zip`; a.click(); URL.revokeObjectURL(a.href);
      toast.success("Share kit downloaded");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="space-y-4 rounded-xl border bg-card p-6" data-testid="share-kit">
      <div><p className="eyebrow flex items-center gap-2"><Megaphone className="h-4 w-4" />Share this project</p>
        <p className="mt-1 text-sm text-muted-foreground">{complete ? "It's live in your lookbook. Share the link, or grab the kit for Projekt Network." : "Mark the project Complete (and keep “Show in lookbook” on) to share it publicly. You can download the kit any time."}</p></div>
      {complete && <ShareBar compact url={shareUrl} title={project.name} text={project.description} image={`${api_base}/api/og/project/${project.id}.png`} />}
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" className="rounded-full" onClick={download} disabled={busy} data-testid="share-kit-download">{busy ? <Spinner /> : <Download className="mr-2 h-4 w-4" />}Download Projekt Network kit</Button>
        <Button asChild variant="ghost" className="rounded-full" data-testid="share-kit-open-pn"><a href="https://projektnetwork.com/construction-projects-in-ontario/#create-a-project" target="_blank" rel="noreferrer">Open Projekt Network <ExternalLink className="ml-2 h-4 w-4" /></a></Button>
      </div>
      <p className="text-xs text-muted-foreground">The kit is a zip with every project image plus a text file (title, location, description, room stories, pieces refinished, suggested trade tags) ready to paste into their “Share a project” form. Projekt Network has no posting API yet, so this is a two-minute copy-paste.</p>
    </section>
  );
}
